export default [
  {name: 'MÂLE', value: 'M'},
  {name: 'FEMALE', value: 'F'},
]



// WEBPACK FOOTER //
// ./src/shared/routers/languages/fr/arrays/sexes.js